export default "__VITE_ASSET__keS6Oe49__"